<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人信息</el-breadcrumb-item>
      <el-breadcrumb-item>授教信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-button type=" success" @click="dialogVisible=true">添加</el-button>
      <el-table ref="" :data="TeacherList" border show-overflow-tooltip="true" tooltip-effect="dark"
        style="width: 100%">
        <el-table-column label="班级名称" width="120" prop="className">
        </el-table-column>
        <el-table-column label="英语老师" width="120" :formatter="stateFormat">
        </el-table-column>

        <el-table-column label="语文老师" width="120" :formatter="stateFormat2">
        </el-table-column>
        <el-table-column label="数学老师" width="120" :formatter="stateFormat3">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="deleteTeacherClass(scope.row)"><svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-shanchu"></use>
              </svg></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="请选择班级" prop="classId">
          <el-select v-model="ruleForm.classId" placeholder="请选择班级">
            <el-option :label="classGre.className" :value="classGre.classId" v-for="(classGre,index) in classList"
              :key="index"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="授教类型">
          <el-checkbox-group v-model="ruleForm.teacherTypes">
            <el-checkbox label="英语老师"></el-checkbox>
            <el-checkbox label="语文老师"></el-checkbox>
            <el-checkbox label="数学老师"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-dialog>


  </div>
</template>

<script>
export default {
  created() {
    this.getTeacherClass()
  },
  data() {
    return {
      classList: '',
      TeacherList: [],
      dialogVisible: false,
      ruleForm: {
        userid: '',
        classId: '',
        teacherTypes: [],
      },
      rules: {
        classId: [
          { required: true, message: '请选择班级', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    getTeacherClass() {
      this.axios.post("/classGrade/getClassGrade")
        .then(res => {
          if (res.data.status == 1) {
            console.log(res.data.result)
            this.classList = res.data.result
          }
        })
      this.axios.post("/teacherClass/getTeacherClass", "teacherId=" + JSON.parse(localStorage.getItem('user')).userid)
        .then(resp => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
            this.TeacherList = resp.data.result
          }
        })
    },
    stateFormat(row, column) {
      if (row.teacherType) {
        return '是'
      } else {
        return '否'
      }
    },
    stateFormat2(row, column) {
      if (row.teacherType2) {
        return '是'
      } else {
        return '否'
      }
    },
    stateFormat3(row, column) {
      if (row.teacherType3) {
        return '是'
      } else {
        return '否'
      }
    }, submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let config = { headers: { "Content-Type": "application/json" } };
          const formData = new FormData()
          formData.append('teacherId', JSON.parse(localStorage.getItem('user')).userid)
          formData.append("classId", this.ruleForm.classId)
          formData.append("teacherTypes", this.ruleForm.teacherTypes)
          console.log(this.ruleForm.teacherTypes)
          this.axios.post("/teacherClass/insertTeacherClass", formData, config)
            .then(resp => {
              if (resp.data.status == 1) {
                this.dialogVisible = false
                this.getTeacherClass()
                this.$message.success("添加成功")
              } else {
                this.$message.error("失败")
              }
            }).catch((err) => {
              alert("出错了")
            })
        }
      })
    }, deleteTeacherClass(data) {
      const that = this
      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确认",//确认按钮文字更换
        cancelButtonText: "取消",//取消按钮文字更换
        showClose: true,//是否显示右上角关闭按钮
        type: "warning",//提示类型  success/info/warning/error
      }).then(function () {
        that.axios.post("/teacherClass/deleteTeacherClass?TeacherId=" + data.teacherClassId)
          .then(resp => {
            if (resp.data.status == 1) {
              that.$message.success("删除成功")
              that.getTeacherClass()
            } else {
              that.$message.error("失败")
            }
          }).catch((err) => {
            alert("出错了")
          })
        console.log(data)
      }).catch(() => { });
    }
  }

}
</script>

<style scoped>
.icon {
  width: 1.2em;
  height: 1.2em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/work/teacher/TeachClass.vue